const state = {
  items: [],
}

const getters = {
  count: state => {
    return state.items.length;
  },
  getById: (state) => (id) => {
    return state.items.find(item => item.id == id);
  },
  getAll: (state) => {
    return state.items;
  },
  canchas: (state) => {
    return [...new Set(state.items.map(item => item.cancha))];
  },
  canchasCombo: (state, getters) => {
    return getters.canchas.map(item => ({value: item, text: item}));
  }
}

const actions = {

  retrieveFromLS ({ commit }) {
    let items = JSON.parse(localStorage.getItem('db.partidos'));
    if (items) commit('setItems', items);
  },

  setAndPersistLS({ dispatch, commit }, items) {
    commit('setItems', items);
    dispatch('persistLS');
  },

  persistLS({ state }) {
    localStorage.setItem('db.partidos', JSON.stringify(state.items));
  }
}


const mutations = {
  setItems (state, items) {
    state.items = items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}